var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(this.detailInfo.title))]),_c('p',{staticClass:"source"},[_c('span',[_vm._v(" "+_vm._s(_vm.detailInfo.source)+" ")])]),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.detailInfo.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }